import { Row, Card, Col, Form } from "react-bootstrap";
import { http } from "Utils/http";
import { useEffect, useReducer, useState, useRef } from "react";
import Stack from 'react-bootstrap/Stack';
import { useLocation, useNavigate } from 'react-router-dom';
import 'react-phone-input-2/lib/style.css'
import { TextButton } from 'Components/Button';
import { ERROR_MESSAGES, ORG_TYPES, USER_ROLES, STATUSES } from "Utils/constants";
import { useDispatch } from "react-redux"
import { setGlobalSuccessStatus, setGlobalErrorStatus } from 'Components/StatusHandling';
import 'react-phone-input-2';
import { GetUserTextInputData, GetOrgTextInputData, GetUserCheckboxInputData, GetUserPhoneInputData, GetUserSelectInputData, GetResetPasswordInputData } from 'Containers/Private/User/UserBeanFields';
import { RoleDataReducer } from "Containers/Private/User/RoleDataReducer";
import { getPrefixAndSuffixList, getRegionList } from 'Utils/utilityFunctions';
import { FormInputDisplay } from 'Components/Forms/FormInputDisplay.js';
import InfoTable from "Components/InfoTable/InfoTable";
//import { redirectDocument } from "react-router-dom";
import { store } from 'Store';
import { resetPassword } from "../UserAxiosFuncs";

function ViewUser () {
    const ACTIONS = {
        CALL_API: 'call-api',
        SUCCESS: 'success',
        ERROR: 'error',
        SET_INITIAL_DATA: 'set-data',

        TEXT_CHANGE: 'text-change',
        TEXT_SET_ERRORS: 'text-set-errors',
        TEXT_REMOVE_ERRORS: 'text-remove-errors',
        TEXT_SET_SUCCESS: 'text-set-success',

        RADIO_CHANGE: 'radio-change',
        RADIO_SET_ERRORS: 'radio-set-errors',
        RADIO_REMOVE_ERRORS: 'radio-remove-errors',

        SELECT_CHANGE: 'select-change',
        SELECT_SET_ERRORS: 'select-set-errors',
        SELECT_REMOVE_ERRORS: 'select-remove-errors',

        SET_INITIAL_CHECK_DATA: 'set-check-data',
        CHECK_CHANGE: 'check-change',
        CHECK_SET_ERRORS: 'check-set-errors',
        CHECK_REMOVE_ERRORS: 'check-remove-errors',
        CHECK_REMOVE_FALSE: 'check-remove-false',

        DATE_CHANGE: 'date-change',
        DATE_SET_ERRORS: 'date-set-errors',
        DATE_REMOVE_ERRORS: 'date-remove-errors',

        PHONE_CHANGE: 'phone-change',
        PHONE_SET_ERRORS: 'phone-set-errors',
        PHONE_REMOVE_ERRORS: 'phone-remove-errors'
    };

    let location = useLocation();
    var passedData = location.state;
    //console.log("view user passedData", passedData);
    const loginState = store.getState().loginInfo;
    const token = "Bearer " + loginState.token;

    const [backRedirect, setBackRedirect] = useState(passedData.backRedirect);
    //const orgType=passedData.orgType;
    const userId = passedData.userId;
    const statusDesc = passedData.statusDesc;
    const isPSOPPCAdmin = passedData.isPSOPPCAdmin;


    //console.log("ORG TYPE ID - " + orgTypeId);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [isLoading, setIsLoading] = useState(true);
    const [changeWSPwdRole, setChangeWSPwdRole] = useState(null);
    const [sftpRole, setSftpRole] = useState(null);
    const [accessToCollabSite, setAccessToCollabSite] = useState(null);
    const [orgTypeId, setOrgTypeId] = useState(null);
    const [orgType, setOrgType] = useState(null);
    const [isTermOfUse, setIsTermOfUse] = useState(null);
    const [contactTypeVisibility, setContactTypeVisibility] = useState({ certifiedContactId: false, primaryContactId: false })

    var roleIdObj = {
        type: 'radio',
        name: "roleId",
        value: '',
        validation: {
            required: true,
            isInvalid: false,
            errors: []
        },
        InputRef: useRef(null)
    }

    const [role, roleInputDispatch] = useReducer(RoleDataReducer, roleIdObj);

    var [orgName, orgNameInputDispatch] = GetOrgTextInputData('name', '', orgType, 'view');
    var [orgPsoId, orgPsoIdInputDispatch] = GetOrgTextInputData('psoId', '', orgType, 'view');

    var [userFirstName, userFirstNameInputDispatch] = GetUserTextInputData('firstname', '', orgType, 'view');
    var [userMiddleName, userMiddleNameInputDispatch] = GetUserTextInputData('middlename', '', orgType, 'view');
    var [userLastName, userLastNameInputDispatch] = GetUserTextInputData('lastname', '', orgType, 'view');
    var [userPrefix, userPrefixInputDispatch] = GetUserSelectInputData('prefix', '', orgType, 'view');
    var [userSuffix, userSuffixInputDispatch] = GetUserSelectInputData('suffix', '', orgType, 'view');
    var [userCredentials, userCredentialsInputDispatch] = GetUserTextInputData('credentials', '', orgType, 'view');
    var [userJobTitle, userJobTitleInputDispatch] = GetUserTextInputData('jobTitle', '', orgType, 'view');
    var [userAddress1, userAddress1InputDispatch] = GetUserTextInputData('address1', '', orgType, 'view');
    var [userAddress2, userAddress2InputDispatch] = GetUserTextInputData('address2', '', orgType, 'view');
    var [userCity, userCityInputDispatch] = GetUserTextInputData('city', '', orgType, 'view');
    var [userState, userStateInputDispatch] = GetUserSelectInputData('state', '', orgType, 'view');
    var [userZip, userZipInputDispatch] = GetUserTextInputData('zip', '', orgType, 'view');
    var [userZipExt, userZipExtInputDispatch] = GetUserTextInputData('zipext', '', orgType, 'view');
    var [userPhone, userPhoneInputDispatch] = GetUserPhoneInputData('phoneForDisplay', '', orgType, 'view');
    var [userPhoneExt, userPhoneExtInputDispatch] = GetUserTextInputData('phonextn', '', orgType, 'view');
    var [userFax, userFaxInputDispatch] = GetUserPhoneInputData('faxForDisplay', '', orgType, 'view');
    var [userEmailAddress, userEmailAddressInputDispatch] = GetUserTextInputData('emailaddress', '', orgType, 'view');
    var [userConfirmEmailAddress, userConfirmEmailAddressInputDispatch] = GetUserTextInputData('confirmemailaddress', '', orgType, 'view');
    var [userContactType, userContactTypeInputDispatch] = GetUserCheckboxInputData('contactType', '', orgType, 'view');
    var [userPassword, userPasswordInputDispatch] = GetResetPasswordInputData('resetUserPassword', '', orgType, 'view');


    // field error key mapping: "user_resetUserPassword": "password"
    const fieldDataAccess = {

        password: { value: userPassword, dispatch: userPasswordInputDispatch }
    }

    const setInitialData = (dispatch, value) => {
        //console.log("setinitialdata", value);
        dispatch({
            type: ACTIONS.SET_INITIAL_DATA,
            value: value
        })
    }

    const setInitialSelectData = (dispatch, options) => {
        //console.log("setinitialselectdata", options);

        dispatch({
            type: ACTIONS.SET_INITIAL_DATA,
            options: options
        })
    }


    const errorHandle = function () {
        setGlobalErrorStatus({
            dispatch: dispatch,
            popupData: {
                visible: true,
                title: ERROR_MESSAGES.GENERAL_ERROR.title,
                msg: ERROR_MESSAGES.GENERAL_ERROR.message,
                showContactHelp: true
            },
            redirect: {
                redirect: false,
                redirectFirst: false,
                path: "",
                data: {}
            }
        })
    };

    const prefixAndSuffix = (errorHandle, value) => {
        getPrefixAndSuffixList(errorHandle, true).then((res) => {
            //console.log(res);
            if (res != null) {
                setInitialSelectData(userPrefixInputDispatch, res.prefixData);
                setInitialSelectData(userSuffixInputDispatch, res.suffixData);
                userPrefixInputDispatch({
                    type: ACTIONS.SELECT_CHANGE,
                    name: userPrefix.name,
                    value: value
                })
                userSuffixInputDispatch({
                    type: ACTIONS.SELECT_CHANGE,
                    name: userSuffix.name,
                    value: value
                })
            }
            return res;
        });
    }

    const region = (errorHandle, value) => {
        getRegionList(errorHandle, true).then((res) => {
            //console.log(res);
            if (res != null) {
                setInitialSelectData(userStateInputDispatch, res.stateData);
                userStateInputDispatch({
                    type: ACTIONS.SELECT_CHANGE,
                    name: userState.name,
                    value: value
                })
            }
            return res;
        });
    }

    const handleBack = async () => {
        //console.log("BACK");
        //console.log(backRedirect);
        //navigate(-1);
        //redirectDocument("/manage/user");
        if (backRedirect.path == null) {
            setBackRedirect("/manage/user");
        }
        navigate(
            backRedirect.path,
            { state: backRedirect.state }
        );
    };



    const loadUserData = async () => {

        //console.log("viewUser");
        var url = '/api/manage/users/viewuser';
        var values = {
            userId: userId
        }
        const loginState = store.getState().loginInfo;
        //console.log(values);
        setIsLoading(true);

        const res = http.post(url, values, {
            headers: {
                "Authorization": "Bearer " + loginState.token
            }
        }).then((response) => {
            if (response != null) {
                //console.log("/api/manage/users/viewuser", response);
                var statusCode = response.status;
                if (statusCode != 1) {
                    setGlobalErrorStatus({
                        dispatch: dispatch,
                        popupData: {
                            visible: true,
                            title: ERROR_MESSAGES.GENERAL_ERROR.title,
                            msg: ERROR_MESSAGES.GENERAL_ERROR.message,
                            showContactHelp: true
                        },
                        redirect: {
                            redirect: false,
                            redirectFirst: false,
                            path: "",
                            data: {}
                        }
                    });
                }
                else {

                    //setOrgType();
                    setOrgTypeId(response.data.orgTypeId);
                    setIsTermOfUse(response.data.agreedToTermsOfUse);
                    prefixAndSuffix(errorHandle, { prefixId: response.data.prefixId, suffixId: response.data.suffixId });
                    region(errorHandle, response.data.state);


                    setInitialData(orgNameInputDispatch, response.data.orgname);
                    setInitialData(orgPsoIdInputDispatch, response.data.psoId);
                    setInitialData(userFirstNameInputDispatch, response.data.firstname);
                    setInitialData(userMiddleNameInputDispatch, response.data.middlename);
                    setInitialData(userLastNameInputDispatch, response.data.lastname);

                    setInitialData(userCredentialsInputDispatch, response.data.credentials);
                    setInitialData(userJobTitleInputDispatch, response.data.jobTitle);
                    setInitialData(userAddress1InputDispatch, response.data.address1);
                    setInitialData(userAddress2InputDispatch, response.data.address2);
                    setInitialData(userCityInputDispatch, response.data.city);

                    setInitialData(userZipInputDispatch, response.data.zip);
                    setInitialData(userZipExtInputDispatch, response.data.zipext);
                    setInitialData(userPhoneInputDispatch, response.data.phoneForDisplay);
                    setInitialData(userPhoneExtInputDispatch, response.data.phonextn);
                    setInitialData(userFaxInputDispatch, response.data.faxForDisplay);
                    setInitialData(userEmailAddressInputDispatch, response.data.emailaddress);
                    setInitialData(userConfirmEmailAddressInputDispatch, response.data.confirmemailaddress);

                    //setInitialData(userContactTypeInputDispatch, response.data.certifiedcontactid);
                    //setInitialData(userContactTypeInputDispatch, response.data.primarycontactid);


                    setContactTypeVisibility({ primaryContactId: response.data.primarycontactid, certifiedContactId: response.data.certifiedcontactid })

                    userContactTypeInputDispatch({
                        type: ACTIONS.CHECK_CHANGE,
                        name: 'certifiedcontactid',
                        value: response.data.certifiedcontactid,
                        checked: response.data.certifiedcontactid
                    })

                    userContactTypeInputDispatch({
                        type: ACTIONS.CHECK_CHANGE,
                        name: 'primarycontactid',
                        value: response.data.primarycontactid,
                        checked: response.data.primarycontactid
                    })

                    userContactTypeInputDispatch({
                        type: ACTIONS.CHECK_REMOVE_FALSE
                    })

                    //setInitialData(roleCheckInputDispatch, response.data.sftpRoleForLevel3);
                    //setInitialData(roleCheckInputDispatch, response.data.sftpRoleForPSOAdmin);
                    //setInitialData(roleCheckInputDispatch, response.data.changeWSPwdRoleForLevel3);
                    //setInitialData(roleCheckInputDispatch, response.data.changeWSPwdRoleForPSOAdmin);

                    setChangeWSPwdRole(response.data.changeWSPwdRole);
                    setSftpRole(response.data.sftpRole);
                    setAccessToCollabSite(response.data.accessToCollabSite);

                    //setInitialData(accountRolesAdditionalAccessInputDispatch, response.data.accessToCollabSite);

                    //setInitialData(roleInputDispatch, response.data.roleId);
                    roleInputDispatch({
                        type: ACTIONS.RADIO_CHANGE,
                        name: role.name,
                        value: response.data.roleName
                    })
                    setIsLoading(false);

                }

            }
            else {
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true,
                        title: ERROR_MESSAGES.GENERAL_ERROR.title,
                        msg: ERROR_MESSAGES.GENERAL_ERROR.message,
                        showContactHelp: true
                    },
                    redirect: {
                        redirect: false,
                        redirectFirst: false,
                        path: "",
                        data: {}
                    }
                });
                //dispatch(setStatus(STATUSES.ERROR));
                //dispatch(setPopup({visible: true, title: ERROR_MESSAGES.DATA_ERROR.title, msg: ERROR_MESSAGES.DATA_ERROR.message, showContactHelp: true }));
            }
        }).catch(function (error) {
            //console.log(error);
            //setIsLoading(false);
            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.GENERAL_ERROR.title,
                    msg: ERROR_MESSAGES.GENERAL_ERROR.message,
                    showContactHelp: true
                },
                redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                },
                error: error
            });
        });
        //console.log(res);
        return res;

    };

    const infoTableData = function () {
        var data = [];

        data.push(
            {
                name: "Account Role",
                value: role.value
            }
        );
        data.push(
            {
                name: "Account Status",
                value: statusDesc
            }
        );
        if (orgTypeId == ORG_TYPES.PSO.types.PSO.id || orgTypeId == ORG_TYPES.Vendor.types.Vendor.id) {
            if (role.value != USER_ROLES.LEVEL1.value && role.value != USER_ROLES.LEVEL2.value) {
                data.push(
                    {
                        name: "Receive SFTP Email",
                        value: sftpRole ? "Yes" : "No"
                    }
                );
                data.push(
                    {
                        name: "Change Web Service Password",
                        value: changeWSPwdRole ? "Yes" : "No"
                    }
                );
            }

        }
        if (orgTypeId == ORG_TYPES.PSO.types.PSO.id || orgTypeId == ORG_TYPES.Admin.types.Top_Level.id || orgTypeId == ORG_TYPES.Admin.types.AHRQ.id) {
            data.push(
                {
                    name: "Help Center Access",
                    value: accessToCollabSite ? "Yes" : "No"
                }
            );
        }
        return data;
    }


    function addErrorMessages (object, fieldErrors, dispatch, isFirst) {
        //console.log("ADD ERROR MESSAGES");
        //console.log(object);
        //console.log(fieldErrors);
        var err = [];
        var type = object.type;

        if (fieldErrors != null) {
            err = fieldErrors.errorMessages;

            if (isFirst == true) {
                (object.InputRef).current.focus();
                //console.log("ISFIRST");
            }
        }


        switch (type) {
            case "text":
                dispatch({
                    type: ACTIONS.TEXT_SET_ERRORS,
                    errors: err
                })
                break;
            case "date":
                dispatch({
                    type: ACTIONS.TEXT_SET_ERRORS,
                    //name: fieldName,
                    errors: err
                })
                break;
            case "select":
                dispatch({
                    type: ACTIONS.SELECT_SET_ERRORS,
                    //name: fieldName,
                    errors: err
                })
                break;
            case "radio":
                dispatch({
                    type: ACTIONS.RADIO_SET_ERRORS,
                    //name: fieldName,
                    errors: err
                })
                break;
            case "checkbox":
                dispatch({
                    type: ACTIONS.CHECK_SET_ERRORS,
                    //name: fieldName,
                    errors: err
                })
                break;
            case "tel":
                dispatch({
                    type: ACTIONS.PHONE_SET_ERRORS,
                    //name: fieldName,
                    errors: err
                })
                break;
            case "password":
                dispatch({
                    type: ACTIONS.TEXT_SET_ERRORS,
                    //name: fieldName,
                    errors: err
                })
                break;
        }
    }

    useEffect(() => {
        //console.log(backRedirect);
        loadUserData();
    }, []);

    // trigger reset password email 
    const handleResetPassword = async (tokenType) => {
        //console.log("handleResetPassword token type", tokenType);
        setInitialData(userPasswordInputDispatch, "");
        resetPassword(token, userId, userPassword.value, tokenType)
            .then((res) => {
                if (res !== null && res !== undefined) {
                    //console.log("handleResetPassword", res, res.data.status, Object.keys(res.data.fieldErrors).length);
                    let statusCode = res.data.status;
                    statusCode < 0 ? statusCode = STATUSES.ERROR.code : statusCode = STATUSES.SUCCESS.code;

                    switch (statusCode) {
                        case STATUSES.ERROR.code:
                            // handle global error and popup
                            if (res.data.globalErrorMessageList && res.data.globalErrorMessageList.length != 0) {
                                setGlobalErrorStatus({
                                    dispatch: dispatch,
                                    popupData: {
                                        visible: true,
                                        title: ERROR_MESSAGES.GENERAL_ERROR.title,
                                        msg: res.data.globalErrorMessageList,
                                        showContactHelp: true
                                    },
                                    redirect: {
                                        redirect: false,
                                        redirectFirst: false,
                                        path: "",
                                        data: {}
                                    }
                                })
                            };

                            // handle field error
                            if (Object.keys(res.data.fieldErrors).length != 0) {
                                //console.log("print out res,data.fieldErrors", res.data.fieldErrors);
                                var d = res.data.fieldErrors;
                                var x = 0;
                                var isFirst = false;
                                for (const [key, value] of Object.entries(fieldDataAccess)) {
                                    var values = d[key];
                                    var disp = value.dispatch;
                                    var obj = value.value;
                                    if (values != null) {
                                        if (x == 0) {
                                            isFirst = true;
                                        }
                                        else {
                                            isFirst = false;
                                        }
                                        addErrorMessages(obj, values, disp, isFirst);
                                        x = x + 1;
                                    }
                                    else {
                                        addErrorMessages(obj, null, disp, false);
                                    }
                                }
                            }
                            break;
                        case STATUSES.SUCCESS.code:
                            // clear input field
                            setInitialData(userPasswordInputDispatch, "");
                            setGlobalSuccessStatus({
                                dispatch: dispatch,
                                popupData: {
                                    visible: true,
                                    title: "Success!",
                                    msg: res.data.message,
                                    showContactHelp: false
                                },
                                redirect: {
                                    redirect: false,
                                    redirectFirst: false,
                                    path: "",
                                    data: {}
                                }
                            });
                            break;
                    }
                }
            }).catch(function (error) {
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true,
                        title: ERROR_MESSAGES.DATA_ERROR.title,
                        msg: ERROR_MESSAGES.DATA_ERROR.message,
                        showContactHelp: true
                    },
                    redirect: {
                        redirect: false,
                        redirectFirst: false,
                        path: "",
                        data: {}
                    },
                    error: error
                });
                return error.response;
            })
    }

    return (
        <Row >
            {isLoading
                ? null
                :
                <Row >
                    <Col xl={11} lg={11} md={11} sm={12}>
                        <Card className="p-4" >
                            <Card.Body className="text-start">

                                <Row>
                                    <h1 id="mainContent" className="header1 text-start mb-3 blue bold">View User Information</h1>
                                </Row>
                                <Row>
                                    <Form>

                                        <h2>Organization Information</h2>
                                        {/*
                                                Organization Name
                                                Organization ID
                                            */}
                                        <FormInputDisplay fieldData={orgName} inputDispatch={orgNameInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                        <FormInputDisplay fieldData={orgPsoId} inputDispatch={orgPsoIdInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>


                                        <h2>Account Information</h2>
                                        <Col
                                            md={12}
                                            lg={12}
                                            xl={12}

                                        >
                                            <InfoTable
                                                data={infoTableData()}
                                                colSizes={{
                                                    label: {
                                                        xl: 4,
                                                        lg: 5,
                                                        md: 6,
                                                        sm: 6,
                                                        xs: 6
                                                    },
                                                    value: {
                                                        xl: 8,
                                                        lg: 7,
                                                        md: 6,
                                                        sm: 6,
                                                        xs: 6
                                                    }
                                                }}
                                            ></InfoTable>

                                        </Col>
                                        {/*Reset Password/Send welcome email: hide it if the user is not active */}
                                        {
                                            isPSOPPCAdmin !== true
                                                ? null
                                                : isTermOfUse === 1 ?
                                                    statusDesc === "Active" ?
                                                        <>
                                                            <h2>Reset Password</h2>
                                                            <p className="text-start">Enter your password to send user a reset password email.</p>
                                                            <FormInputDisplay fieldData={userPassword} inputDispatch={userPasswordInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={true} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                                            <TextButton
                                                                variant="normal"
                                                                onClick={() => handleResetPassword("RESET_PSWD")}
                                                                content={"Reset Password"}
                                                                className="ms-auto"
                                                            >
                                                            </TextButton>

                                                        </> : null
                                                    :
                                                    statusDesc === "Active" ?
                                                        <>
                                                            <h2>Welcome Email</h2>
                                                            <p className="text-start">This user has not yet logged in. Use the button  below to resend the Welcome Email.</p>
                                                            <FormInputDisplay fieldData={userPassword} inputDispatch={userPasswordInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={true} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                                            <TextButton
                                                                variant="normal"
                                                                onClick={() => handleResetPassword("NEW_USER")}
                                                                content={"Resend Welcome Email"}
                                                                className="ms-auto"
                                                            >
                                                            </TextButton>
                                                        </> : null


                                        }



                                        <h2>User Information</h2>
                                        <FormInputDisplay fieldData={userFirstName} inputDispatch={userFirstNameInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                        <FormInputDisplay fieldData={userMiddleName} inputDispatch={userMiddleNameInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                        <FormInputDisplay fieldData={userLastName} inputDispatch={userLastNameInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                        <FormInputDisplay fieldData={userPrefix} inputDispatch={userPrefixInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                        <FormInputDisplay fieldData={userSuffix} inputDispatch={userSuffixInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                        <FormInputDisplay fieldData={userCredentials} inputDispatch={userCredentialsInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                        <FormInputDisplay fieldData={userJobTitle} inputDispatch={userJobTitleInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                        <FormInputDisplay fieldData={userAddress1} inputDispatch={userAddress1InputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                        <FormInputDisplay fieldData={userAddress2} inputDispatch={userAddress2InputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                        <FormInputDisplay fieldData={userCity} inputDispatch={userCityInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                        <FormInputDisplay fieldData={userState} inputDispatch={userStateInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                        <FormInputDisplay fieldData={userZip} inputDispatch={userZipInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                        <FormInputDisplay fieldData={userZipExt} inputDispatch={userZipExtInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                        <FormInputDisplay fieldData={userPhone} inputDispatch={userPhoneInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                        <FormInputDisplay fieldData={userPhoneExt} inputDispatch={userPhoneExtInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                        <FormInputDisplay fieldData={userFax} inputDispatch={userFaxInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                        <FormInputDisplay fieldData={userEmailAddress} inputDispatch={userEmailAddressInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                        <FormInputDisplay fieldData={userConfirmEmailAddress} inputDispatch={userConfirmEmailAddressInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>

                                        {(contactTypeVisibility.certifiedContactId == true || contactTypeVisibility.primaryContactId == true) && (orgTypeId == ORG_TYPES.PSO.types.PSO.id || orgTypeId == ORG_TYPES.Vendor.types.Vendor.id) ?
                                            <>
                                                <h2>Contact Types</h2>
                                                <FormInputDisplay fieldData={userContactType} inputDispatch={userContactTypeInputDispatch} orgType={orgType} isHorizontal={true} hideLabel={true} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }}></FormInputDisplay>
                                            </>
                                            : null
                                        }

                                        <Stack direction="horizontal" gap={3}>
                                            {/* Back Button */}
                                            <TextButton
                                                variant="outline"
                                                onClick={handleBack}
                                                content={"Back"}
                                                className="ms-auto"
                                            >
                                            </TextButton>
                                        </Stack>
                                    </Form>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            }
        </Row>
    );
}


export default ViewUser;

/*const resetPassword = async() => {
    //console.log("resetPassword");
    var url = "/api/manage/users/resetpassword";
    var values = {
        password : userPassword.value,
        userId: userId
    };
    const res = http.post(url, values,{
        maxContentLength: 10000000,
        maxBodyLength: 10000000,
        timeout: 35000, // Set a timeout of 5 seconds
        headers: {
            //"Authorization": "Bearer " + loginState.token
        }
    }).then((response) => {
        //console.log("response");
        //console.log(response);
        if(response!=null){
            //console.log(response);
            var statusCode = response.status;
            if(statusCode!=1){
                
            }
            else{  
                userPasswordInputDispatch ({
                    type: ACTIONS.TEXT_SET_SUCCESS,
                    successMsgs: [response.message]
                })
            }
        }
        else{
            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true, 
                    title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                    msg: ERROR_MESSAGES.GENERAL_ERROR.message, 
                    showContactHelp: true 
                },
                redirect: {
                    redirect: false, 
                    redirectFirst: false,
                    path: "", 
                    data: {}
                }
            });
        }
    }).catch(function (error) {
        //console.log(error);
        setGlobalErrorStatus({
            dispatch: dispatch,
            popupData: {
                visible: true, 
                title: ERROR_MESSAGES.GENERAL_ERROR.title, 
                msg: ERROR_MESSAGES.GENERAL_ERROR.message, 
                showContactHelp: true 
            },
            redirect: {
                redirect: false, 
                redirectFirst: false,
                path: "", 
                data: {}
            }
        });
    });
    //console.log(res);
    return res;
}*/